module.exports = __webpack_public_path__ + "static/broadcaster_sec3_1_2-f161f9b1737597d069af91294b15d1db.png";